import { type FC, memo } from "react";
import { partnerLogoContainer } from "src/website-apps/responsive/stubhub-performer/components/performer-info-card/styles";
import { Image, ImageSize } from "src/website-apps/shared/components/image";

interface Props {
  /** URL of the partner logo image */
  partnerLogoUrl: string;
  /** Color of the partner */
  partnerColor: string;
  /** Callback for when the image loads */
  onLoad: () => void;
  /** Whether the logo is short */
  isShort?: boolean;
  /** Whether to remove border radius */
  noBorderRadius?: boolean;
}

/**
 * Partner logo inside partner logo image
 */
export const PartnerLogoImage: FC<Props> = memo(
  ({ partnerLogoUrl, partnerColor, onLoad, isShort, noBorderRadius = false }) => (
    <div
      className={partnerLogoContainer({
        height: isShort ? "short" : "normal",
        corners: noBorderRadius ? "none" : "blockStartRounded",
      })}
      style={{ backgroundColor: partnerColor }}
    >
      <Image
        alt="team logo"
        src={partnerLogoUrl}
        size={isShort ? ImageSize.PortalPartnerLogoSmall : ImageSize.PortalPartnerLogoLarge}
        onLoad={onLoad}
      />
    </div>
  ),
);
PartnerLogoImage.displayName = "PartnerLogoImage";
